function ScrollDown(container) {
    this.container = container;
    this.el = this.container.querySelector('.jsScrollDown');

    this.el.addEventListener('click', e => {
        e.preventDefault();

        const rect = document.querySelector('.jsScrollDownTarget').getBoundingClientRect();
        TweenLite.to(window, 0.9, { scrollTo: rect.top - 80, ease: Power2.easeInOut });
    });

    this.animate();

    // Fade the element out on scroll
    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({ offset: 0, duration: 400 })
        .setTween(this.el, { y: -30, opacity: 0 })
        .addTo(controller)
    ;
};

ScrollDown.prototype.animate = function() {
    const lines = this.el.querySelectorAll('.line');

    new TimelineMax({ repeat: -1 })
        .staggerTo(lines, 0.5, { opacity: 1, ease: Power2.easeIn }, '0.05', '0.5')
        .staggerTo(lines, 0.5, { opacity: 0.2, ease: Power2.easeOut }, '0.05', '-=0.2')
    ;
};